import moment from 'moment'

export default function (input, format = 'MM/DD/YYYY') {
	if( input ) {
		return moment( input ).format(format)
	}
}


// WEBPACK FOOTER //
// ./src/lib/filters/dateFormat.js